import React from "react";

import { ContactWizard } from "./index.jsx";

const Overview = ({ user, afterSubmit, isRC }) => {
  return (
    <div className="overview">
      <ContactWizard
        user={user}
        afterSubmit={afterSubmit}
        isRC={isRC}
        submitLabel="Save changes"
      />
    </div>
  );
};

export default Overview;
